const isSupported = () =>
    'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window
    

//does a request in the browser asking the user if they want to allow sending notifications from this website.
export function requestNotifications() {
    isSupported().then((supported) => {
        if (supported) {
            if (Notification.permission !== 'granted') {
                Notification.requestPermission().then(function (permission) {
                    if (permission === 'granted') {
                        new Notification('Je kunt nu notificaties ontvangen van Mijn auto snel weg!');
                    }
                });
            }
        }
    });
}

//shows a notification with the given title and options
export function showNotification(title, options) {
    if (getNotificationStatus() === 'granted') {
        new Notification(title, options);
    }
}
